import audio from './audio.png';
import defaultImg from './default.png';
import excel from './excel.png';
import image from './image.png';
import miaoji from './miaoji.svg';
import pdf from './pdf.png';
import video from './video.png';
import ziprar from './ziprar.png';

export default {
  default: defaultImg,
  audio,
  excel,
  image,
  miaoji,
  pdf,
  video,
  ziprar
};
